import React, { Component } from 'react';
import Modal from 'react-modal';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import { withRouter } from 'react-router-dom';
import LenderUpdateModalUI from './LenderUpdateModalUI';
class LenderUpdateModalSF extends Component {
	constructor(props) {
		super(props);
		this.state = {
			successMsg: null,
			errorList: null,
			submitted: false,
			lender: '',
			lenderError: null,
		};
	}
	render() {
		const lendersList = [
			{key: 'dfc', value: 'dfc'},
			{key: 'icici', value: 'icici'},
			{key: 'sidbi', value: 'sidbi'},
			{key: 'csfb1', value: 'csfb1'},
			{key: 'csfb2', value: 'csfb2'},
			{key: 'NA', value: 'NA'}
		]
		return (
			<LenderUpdateModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				createMode={this.props.lenderUpdateMode}
				submitted={this.state.submitted}
				onSubmit={this.onSubmit}
				onCancelCreate={this.onCancelCreate}
				lender={this.state.lender}
				lendersList={lendersList}
				onLenderChange={(event) => this.setState({ lender: event.target.value })}
				lenderError={this.state.lenderError}
				setLenderError={(error) => this.setState({ lenderError: error })}
			/>
		);
	}
	componentDidMount() {
		Modal.setAppElement('body');
	}
	onCancelCreate = () => {
		this.setState({
			submitted: false,
			errorList: null,
		});
		this.props.onCancelCreate();
	}
	onSubmit = () => {
		if (this.state.submitted) return;
		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true,
		});
		let accountIdOrLoanId = this.props.account?this.props.account.accountId:this.props.loan.loanId;
		let accountsOrLoans = this.props.account?'accounts':'loans';
		RestApiUtils.put(
			this.props.context,
			`/api/su/${accountsOrLoans}/${accountIdOrLoanId}/lender`,
			this.onSubmitCallback,
			{
				lender: this.state.lender,
			}
		);
	}
	onSubmitCallback = (response) => {
		let errorList = [];
		if (response.errorList) {
			errorList = response.errorList.map((error) => error.message);
		}
		this.setState({
			successMsg: response.success || null,
			errorList: errorList,
			submitted: false,
		});
		if (errorList.length === 0) {
			setTimeout(() => {
				this.setState({ successMsg: null });
				this.props.onCancelCreate();
				this.props.onRefreshClick();
			}, 1000);
		}
	}
	setErrorList = (errorList) => {
		this.setState({ errorList: errorList });
	}
}
export default withRouter(LenderUpdateModalSF);